"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Heading from "./webflow_modules/Basic/components/Heading";
import Image from "./webflow_modules/Basic/components/Image";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";
import RichText from "./webflow_modules/Basic/components/RichText";
import Section from "./webflow_modules/Layout/components/Section";
import Span from "./webflow_modules/Basic/components/Span";
import Strong from "./webflow_modules/Basic/components/Strong";
import * as _interactions from "./webflow_modules/interactions";
import { Footer } from "./Footer";
import { Gallery } from "./Gallery";
import { GlobalStyles } from "./GlobalStyles";
import { HeroSubCardComponentContainer } from "./HeroSubCardComponentContainer";
import { Navbar } from "./Navbar";

const _interactionsData = JSON.parse(
  '{"events":{"e-31":{"id":"e-31","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-32"}},"mediaQueries":["main"],"target":{"selector":".navbar_interaction-trigger","originalId":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"CLASS"},"targets":[{"id":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1702402485163},"e-32":{"id":"e-32","name":"","animationType":"custom","eventTypeId":"SCROLL_OUT_OF_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-16","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-31"}},"mediaQueries":["main"],"target":{"selector":".navbar_interaction-trigger","originalId":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"CLASS"},"targets":[{"id":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1702402485163},"e-129":{"id":"e-129","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-55","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-130"}},"mediaQueries":["main"],"target":{"id":"047ca610-a783-f54c-0b7f-4686678bd700","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"047ca610-a783-f54c-0b7f-4686678bd700","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1707941518035},"e-130":{"id":"e-130","name":"","animationType":"preset","eventTypeId":"SCROLL_OUT_OF_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-56","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-129"}},"mediaQueries":["main"],"target":{"id":"047ca610-a783-f54c-0b7f-4686678bd700","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"047ca610-a783-f54c-0b7f-4686678bd700","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1707941518035}},"actionLists":{"a-15":{"id":"a-15","title":"Navbar [transparent]","actionItemGroups":[{"actionItems":[{"id":"a-15-n","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]},{"actionItems":[{"id":"a-15-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]}],"useFirstGroupAsInitialState":true,"createdOn":1702402503174},"a-16":{"id":"a-16","title":"Navbar [solid]","actionItemGroups":[{"actionItems":[{"id":"a-16-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":1}}]}],"useFirstGroupAsInitialState":false,"createdOn":1702402503174},"a-55":{"id":"a-55","title":"Navbar [transparent] 3","actionItemGroups":[{"actionItems":[{"id":"a-55-n","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]},{"actionItems":[{"id":"a-55-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]}],"useFirstGroupAsInitialState":true,"createdOn":1702402503174},"a-56":{"id":"a-56","title":"Navbar [solid] 3","actionItemGroups":[{"actionItems":[{"id":"a-56-n","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":1}}]}],"useFirstGroupAsInitialState":false,"createdOn":1702402503174}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function PageComponentWebsiteDisclaimer({}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <Block tag={"div"}>
      <GlobalStyles />
      <Block className={"page-wrapper"} tag={"div"}>
        <Block
          className={"navbar_interaction-trigger"}
          data-w-id={"047ca610-a783-f54c-0b7f-4686678bd700"}
          tag={"div"}
        />
        <Navbar />
        <Block className={"main-wrapper"} tag={"main"}>
          <Block className={"header"} tag={"header"}>
            <Block className={"padding-global"} tag={"div"}>
              <Block className={"container-small"} tag={"div"}>
                <Block className={"header30_content"} tag={"div"}>
                  <Block className={"padding-section-large"} tag={"div"}>
                    <Block className={"text-align-center"} tag={"div"}>
                      <Heading className={"text-color-white"} tag={"h1"}>
                        <Strong>{"WEBSITE DISCLAIMER "}</Strong>
                      </Heading>
                    </Block>
                  </Block>
                </Block>
              </Block>
            </Block>
            <Block className={"header30_background-image-wrapper"} tag={"div"}>
              <Block className={"image-overlay-layer"} tag={"div"} />
              <Image
                alt={""}
                className={"header30_background-image"}
                height={"auto"}
                loading={"eager"}
                src={
                  "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657cc1e87bc911eb83bd6937_Rectangle%20100.jpg"
                }
                width={"auto"}
              />
            </Block>
          </Block>
          <Section className={"map"} tag={"section"}>
            <Block className={"padding-global"} tag={"div"}>
              <Block className={"container-large"} tag={"div"}>
                <Block className={"padding-section-large"} tag={"div"}>
                  <RichText
                    className={"trb-pricacy"}
                    tag={"div"}
                    target={"_blank"}
                  >
                    <Heading tag={"h1"}>
                      <Strong>{"WEBSITE DISCLAIMER "}</Strong>
                    </Heading>
                    <Paragraph>
                      <Strong>
                        {
                          "The information provided by SRG Residential (“we,” “us” or “our”) on https://www.srgliving.com (the “Site”) is for general informational purposes only. All information on the Site is provided in good faith, however we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability or completeness of any information on the Site . UNDER NO CIRCUMSTANCE SHALL WE HAVE ANY LIABILITY TO YOU FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF THE SITE OR RELIANCE ON ANY INFORMATION PROVIDED ON THE SITE . YOUR USE OF THE SITE AND YOUR RELIANCE ON ANY INFORMATION ON THE SITE IS SOLELY AT YOUR OWN RISK."
                        }
                      </Strong>
                    </Paragraph>
                    <Paragraph>{"‍"}</Paragraph>
                    <Heading tag={"h2"}>
                      <Strong>{"PRICING DISCLAIMER "}</Strong>
                    </Heading>
                    <Paragraph>
                      <Strong>
                        {
                          "The Site may contain outdated rent pricing information. Despite our best efforts to provide accurate information, it is not possible to ensure that all information is constantly correct. The materials contained on this Site could include technical inaccuracies or typographical errors. We assume no responsibility for any actions taken as a result of using this Site, or for errors or omissions in the materials on this server."
                        }
                      </Strong>
                    </Paragraph>
                    <Paragraph>{"‍"}</Paragraph>
                    <Heading tag={"h2"}>
                      <Strong>{"EXTERNAL LINKS DISCLAIMER "}</Strong>
                    </Heading>
                    <Paragraph>
                      <Strong>
                        {
                          "The Site may contain (or you may be sent through the Site) links to other websites or content belonging to or originating from third parties or links to websites and features in banners or other advertising. Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity, reliability, availability or completeness by us. WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR THE ACCURACY OR RELIABILITY OF ANY INFORMATION OFFERED BY THIRD-PARTY WEBSITES LINKED THROUGH THE SITE OR ANY WEBSITE OR FEATURE LINKED IN ANY BANNER OR OTHER ADVERTISING. WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. "
                        }
                      </Strong>
                    </Paragraph>
                    <Paragraph>{"‍"}</Paragraph>
                    <Heading tag={"h2"}>
                      <Strong>{"TESTIMONIALS DISCLAIMER "}</Strong>
                    </Heading>
                    <Paragraph>
                      <Strong>
                        {
                          "The Site may contain testimonials by users of our products and/or services. These testimonials reflect the real-life experiences and opinions of such users. However, the experiences are personal to those particular users, and may not necessarily be representative of all users of our products and/or services. We do not claim, and you should not assume, that all users will have the same experiences. YOUR INDIVIDUAL RESULTS MAY VARY. The testimonials on the Site are submitted in various forms such as text, audio and/or video, and are reviewed by us before being posted. Testimonials may be edited to select a section of the text.The views and opinions contained in the testimonials belong solely to the individual user and do not reflect our views and opinions. We are not affiliated with users who provide testimonials, and users are not paid or otherwise compensated for their testimonials."
                        }
                      </Strong>
                    </Paragraph>
                    <Paragraph>{"‍"}</Paragraph>
                  </RichText>
                </Block>
              </Block>
            </Block>
          </Section>
          <Section className={"current-residents"} tag={"section"}>
            <Block className={"padding-global"} tag={"div"}>
              <Block className={"container-large"} tag={"div"} />
            </Block>
          </Section>
          <HeroSubCardComponentContainer />
          <Section
            className={"difference_component background-color-grey"}
            tag={"section"}
          >
            <Block className={"padding-global mobile-none"} tag={"div"}>
              <Block className={"container-large"} tag={"div"}>
                <Block tag={"div"}>
                  <Block className={"mobile-padding-global"} tag={"div"}>
                    <Block className={"communities_header"} tag={"div"}>
                      <Block
                        className={"difference_heading-wrapper"}
                        tag={"div"}
                      >
                        <Heading tag={"h2"}>
                          {"THE SRG "}
                          <Span className={"text-color-blue"}>
                            {"Difference"}
                          </Span>
                        </Heading>
                      </Block>
                      <Block
                        className={"decoration-line is-black"}
                        tag={"wrapper"}
                      />
                    </Block>
                  </Block>
                  <Block className={"div-block-34"} tag={"div"}>
                    <Block className={"mobile-padding-global"} tag={"div"}>
                      <Block className={"max-width-medium"} tag={"div"}>
                        <Paragraph className={"text-size-medium"}>
                          {
                            "At SRG Residential, we take utmost pride in being a reliable support system for our residents and employees, fostering strong and vibrant communities where everyone feels valued and cared for. We understand the importance of loving where you live and that's why we are committed to providing hassle-free living experiences."
                          }
                        </Paragraph>
                      </Block>
                    </Block>
                    <Block className={"stats-background is-grey"} tag={"div"}>
                      <Block tag={"div"}>
                        <Block
                          className={"heading-style-h6 text-color-black"}
                          tag={"div"}
                        >
                          {"Locations"}
                        </Block>
                        <Block
                          className={"heading-style-h1 text-color-blue"}
                          tag={"div"}
                        >
                          {"150+"}
                        </Block>
                      </Block>
                      <Block tag={"div"}>
                        <Block
                          className={"heading-style-h6 text-color-black"}
                          tag={"div"}
                        >
                          {"Founded"}
                        </Block>
                        <Block
                          className={"heading-style-h1 text-color-blue"}
                          tag={"div"}
                        >
                          {"1993"}
                        </Block>
                      </Block>
                    </Block>
                  </Block>
                </Block>
              </Block>
            </Block>
          </Section>
          <Gallery />
        </Block>
        <Footer />
      </Block>
    </Block>
  );
}
